module.exports = __webpack_public_path__ + "static/img/rocker_base.0db7752a.png";